import React, { useState, useEffect, useRef, useCallback } from 'react';
import UserInactivityModal from '../../components/Modals/UserInactivityModal';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import { useHistory } from 'react-router-dom';
import { MAX_INACTIVE_TIME } from '../../utils/complexDocumentConstants';

const UserActivityListener = ({ checkLockStatus }) => {
  
  const templateLockedSelector = useCallback(store => store[CONTEXT_KEYS.TEMPLATE_LOCKED], []);
  const [isTemplateLocked] = useArtboardContext(templateLockedSelector, 'ComplexArtboard');

  const isOpenDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign] = useArtboardContext(isOpenDesignSelector, `UserActivityListener`);

  const history = useHistory();

  const [showModal, setShowModal] = useState(false);

  const savedCallback = useRef();
  const timerRef = useRef(null);

  const handleIdle = useCallback(event => {
    if (event === null) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, []);

  useEffect(() => {
    savedCallback.current = handleIdle;
  }, [handleIdle]);

  useEffect(() => {
    const resetTimerFunc = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        savedCallback.current(null);
      }, MAX_INACTIVE_TIME * 60 * 1000);
    };

    const handler = event => {
      resetTimerFunc();
    };

    if (isTemplateLocked) {
      clearTimeout(timerRef.current);
    } else {
      resetTimerFunc();
    }

    if (!isTemplateLocked) {
      window.addEventListener('mousemove', handler);
      window.addEventListener('click', handler);
    }

    return () => {
      clearTimeout(timerRef.current);
      window.removeEventListener('mousemove', handler);
      window.removeEventListener('click', handler);
    };
  }, [isTemplateLocked]);

  const handleStayButtonClick = useCallback(() => {
    // dummy API call to reset the timer in the backend.
    checkLockStatus();
    savedCallback.current(null);
    setShowModal(false);
  }, []);

  return (
    showModal && (
      <UserInactivityModal
        open={!isOpenDesign && showModal}
        stayInDesignArea={handleStayButtonClick}
        closeDesign={() => {
          setShowModal(false);
          history.push(`/documentTemplates`);
        }}
      />
    )
  );
};

export default UserActivityListener;
